import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SimulationWarrantiesGroupProtectionForm from './SimulationWarrantiesGroupProtectionForm.jsx';

const SimulationWarrantiesGroupProtection = ({ getMiddleText }) => (
  <SimulationWarrantiesGroupProtectionForm getMiddleText={getMiddleText} />
);

export default withMiddleFeatures(SimulationWarrantiesGroupProtection);
